import { render } from "./IntercomScene.vue?vue&type=template&id=1595cb5a&scoped=true"
import script from "./IntercomScene.vue?vue&type=script&lang=js"
export * from "./IntercomScene.vue?vue&type=script&lang=js"

import "./IntercomScene.vue?vue&type=style&index=0&id=1595cb5a&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1595cb5a"]])

export default __exports__